import { render } from "./Speedometer.vue?vue&type=template&id=390f41cc&scoped=true"
import script from "./Speedometer.vue?vue&type=script&lang=js"
export * from "./Speedometer.vue?vue&type=script&lang=js"

import "./Speedometer.vue?vue&type=style&index=0&id=390f41cc&lang=scss&scoped=true"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390f41cc"]])

export default __exports__